import { ComponentRef, Directive, ElementRef, inject, Input, OnDestroy, OnInit } from '@angular/core';

@Directive({
  standalone: true,
})
export class AuditoriumShapeDirective implements OnDestroy, OnInit {

  @Input() componentRef: ComponentRef<any>;

  public static instances: AuditoriumShapeDirective[] = [];

  public elementRef = inject(ElementRef);

  public ngOnInit(): void {
    if (this.componentRef) {
      AuditoriumShapeDirective.instances.push(this);
    }
  }

  public destroy(): void {
    this.componentRef.destroy();
  }

  public ngOnDestroy(): void {
    AuditoriumShapeDirective.instances = AuditoriumShapeDirective.instances.filter((instance) => instance !== this);
  }
}
